import usePosOrderDeliveryCost from "@/shared/atoms/usePosOrderDeliveryCostAtom";
import { useCartTotal } from "@/shared/hooks/useCartHook";
import { useMemo } from "react";
import useCustomDiscountValue from "@/shared/hooks/useCustomDiscountValue";
import usePosOrderTipHook from "@/shared/hooks/usePosOrderTipHook";
import useCartValidatorValuesHook from "./useCartValidatorValuesHook";
import usePosOrderServiceCost from "@/shared/atoms/usePosOrderServiceCostAtom";

const usePosOrderTotalAmountHook = () => {
  const { totalDiscount, totalExtras } = useCartValidatorValuesHook();
  const cartTotal = useCartTotal();
  const [deliveryCost] = usePosOrderDeliveryCost();
  const [serviceCost] = usePosOrderServiceCost();
  const { tipValue } = usePosOrderTipHook();
  const customDiscountValue = useCustomDiscountValue();

  const total = useMemo(
    () =>
      cartTotal +
      (totalExtras || 0) +
      (totalDiscount || 0) -
      (customDiscountValue || 0) +
      (parseFloat(deliveryCost) || 0) +
      (parseFloat(serviceCost) || 0) +
      tipValue,
    [
      cartTotal,
      totalExtras,
      totalDiscount,
      customDiscountValue,
      deliveryCost,
      tipValue,
      serviceCost,
    ],
  );

  return total;
};

export default usePosOrderTotalAmountHook;
